import { Injectable, Signal } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { IRootState } from '../root';

@Injectable({
  providedIn: 'root'
})
export class StateFacade {
  // static readonly rootState = (state: IRootState): IRootState => {
  //   return state;
  // };
  // static readonly rootSelector = createSelector(StateFacade.rootState, (rootState: IRootState) => {
  //   return rootState;
  // });

  // selectRootState(): Observable<IRootState> {
  //   return this.store.select<IRootState>(StateFacade.rootSelector);
  // }

  selectSignal$<T>(selector: (state: IRootState) => T): Signal<T> {
    const featureState$ = this.store.selectSignal<T>(selector);
    return featureState$;
  }

  select$<T>(selector: (state: IRootState) => T): Observable<T> {
    const featureState$ = this.store.select<T>(selector);
    return featureState$;
  }

  dispatch(action: any): void {
    this.store.dispatch(action);
  }

  constructor(private store: Store<IRootState>) {}
}
